import packageInfo from '../../package.json';

export const VERSION = packageInfo.version;
export const APP_NAME = 'WrkFlowPro';
export const BUILD_TIME = new Date().toISOString();

export const getVersionInfo = () => ({
  version: VERSION,
  appName: APP_NAME,
  buildTime: BUILD_TIME,
}); 